import Immutable from 'seamless-immutable';
import {
  SEND_CONTACT_START,
  SEND_CONTACT_SUCCESS,
  SEND_CONTACT_ERROR,
  SEND_CONTACT_RESET
} from '../Actions/Contact';

const initialState = Immutable({
  fetching: false,
  success: false,
  error: null
});

export default function contactReducer(state = initialState, action) {
  switch (action.type) {
    case SEND_CONTACT_START:
      return Immutable.merge(state, {
        fetching: true,
        success: false,
        error: null
      });
    case SEND_CONTACT_SUCCESS:
      return Immutable.merge(state, {
        fetching: false,
        success: true,
        error: null
      });
    case SEND_CONTACT_ERROR:
      return Immutable.merge(state, {
        fetching: false,
        success: false,
        error: action.payload.error
      });
    case SEND_CONTACT_RESET:
      return Immutable.merge(state, {
        fetching: false,
        success: false,
        error: null
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/ContactReducer.js